<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveEmployeeHrNote()">
    <div class="card-body">
      <span style="font-weight: bold; font-size: large;">New Note</span>
      <div class="row">
        <div class="col-12">
          <textarea style="width: 100%;" class="form-control mt-2" formControlName="note" rows="5"></textarea>
          <app-validation-message [form]="form" [path]="'note'" [label]="'Note'"></app-validation-message>
        </div>
      </div>
    </div>
  </form>
  <div class="card mt-2">
    <div class="card-body">
      <span style="font-weight: bold; font-size: large;">Previous Notes</span>
      <div style="max-height: 450px; overflow: auto;">
        <div class="col-12 row mt-2" style="display: inline-flex" *ngFor="let n of Notes">
          <span class="mr-1" style="font-weight: bolder">{{n.writtenByName}}</span> on <span class="ml-1 mr-2" style="font-weight: bolder">{{n.date | date: 'MM/dd/yyyy @ hh:mm:ss a'}}</span> {{n.note}}
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col text-left pl-0">
        <button class="btn btn-secondary" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="saveEmployeeHrNote()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
